import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import App from "./Test";
import "./components/i18n";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
ReactDOM.render(
  <React.StrictMode>
    <Router  history={history}>
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            return (
              // <Redirect to="/enrollment?bde=&src=" />
              <Redirect to="/profile/:uuid" />
            );
          }}
        />
        <Route exact path="/profile/:uuid" component={App} />

        {/* <Route exact path="/profile/:sites/:uuid" component={App} /> */}

        {/* <Route exact path="/thank-you" component={ThankYouPage} /> */}
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
